import Joi from "joi-browser";

const TEMPLATE_REGEX = /\{(.*?)\}/g;

function getAllTemplateParameters(text) {
  const templateParameters = [...text.matchAll(TEMPLATE_REGEX)].map(
    (m) => m[1]
  );

  return Array.from(new Set(templateParameters).values());
}

function processPromptForAttributes(prompt) {
  return getAllTemplateParameters(prompt);
}

const AUTO_POPULATED_VARIABLES = new Set([
  "currentTime",
  "daysReference",
  "daysGreeting",
  "officeHours",
  "isTimeWithinOfficeHours",
  "areHumanAgentsAvailable",
  "emptyCalendarSlots",
  "pastContext",
  "pastConversations",
  "history",
  "input",
  "type",
  "assistantId",
  "conversationId",
  "callId",
  "detectedLanguage",
  "rawCalendarSlots",
  "telephonyCallId",
]);

const AUTO_POPULATED_PREFIXES = ["contextState_"];

const PHONE_CALL_VARIABLES = new Set(["phone", "assistantPhone", "callDirection"]);

function isAutoPopulated(variable, callType) {
  return (
    AUTO_POPULATED_VARIABLES.has(variable) ||
    AUTO_POPULATED_PREFIXES.some((prefix) => variable.startsWith(prefix)) ||
    (callType === "phone" && PHONE_CALL_VARIABLES.has(variable))
  );
}

function getTestCallVariables(text, callType) {
  return processPromptForAttributes(text).filter(
    (variable) => !isAutoPopulated(variable, callType)
  );
}

function generateTemplateForParameter(parameter) {
  const template = {
    name: parameter,
    label: parameter,
    type: "text",
  };

  return template;
}

function generateFormTemplateForParameters(parameters) {
  const formTemplateForParameters = parameters.map((parameter) =>
    generateTemplateForParameter(parameter)
  );

  return formTemplateForParameters;
}

function generateSchemaForParamter(parameter) {
  const schema = {
    [parameter]: Joi.string().allow(null, ""),
  };

  return schema;
}

function generateFormSchemaForParameters(parameters) {
  const formSchemaForParameters = parameters.reduce((acc, parameter) => {
    const parameterSchema = generateSchemaForParamter(parameter);
    return {
      ...acc,
      ...parameterSchema,
    };
  }, {});

  return formSchemaForParameters;
}

function generateInputFieldForParameters(parameters) {
  const inputFieldForParameters = parameters.reduce((acc, parameter) => {
    return {
      ...acc,
      [parameter]: "",
    };
  }, {});

  return inputFieldForParameters;
}

export {
  processPromptForAttributes,
  getTestCallVariables,
  generateFormSchemaForParameters,
  generateFormTemplateForParameters,
  generateInputFieldForParameters,
};